module.exports = __webpack_public_path__ + "static/media/jovica.1a724785.jpg";